


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { AlbumFormat } from '@/components/types'
import AlbumMediaItemImage from '@/components/AlbumMediaItemImage.vue'
import AlbumMediaItemText from '@/components/AlbumMediaItemText.vue'
import { createNamespacedHelpers } from 'vuex'
import MediaItem = gapi.client.photoslibrary.MediaItem;

const { mapActions } = createNamespacedHelpers('photos')

@Component({
  components: { AlbumMediaItemText, AlbumMediaItemImage },
  methods: mapActions([
    'viewMediaItem'
  ])
})
export default class AlbumMediaItem extends Vue {
  @Prop(Object) readonly mediaItem!: MediaItem;
  @Prop(String) readonly format!: AlbumFormat;

  descriptionTheme: string = '';
  viewMediaItem!: (mediaItem: MediaItem|null) => void;

  get description () {
    const description = this.mediaItem.description

    return description ? description.trim() : ''
  }

  created () {
    if (this.description) {
      this.descriptionTheme = `${this.extractDescriptionTheme(this.description)} `
    } else {
      console.warn('Media item does not have description', this.mediaItem)
    }
  }

  view () {
    this.viewMediaItem(this.mediaItem)

    if (typeof this.$gtag !== 'undefined') {
      this.$gtag.event('Click', { event_category: this.format, event_label: this.descriptionTheme })
    }
  }

  private extractDescriptionTheme (description: string) {
    let normalizedDescription = description.replace(/[\u201C\u201D]/g, '"')

    const matches = normalizedDescription.match(/[^"]*"([^"]+)"[^"]*/)

    if (normalizedDescription.split('"').length !== 3 || matches === null) {
      console.warn('Potentially unable to parse description', { description, baseUrl: this.mediaItem.baseUrl })
    }

    return matches === null ? description : matches[1]
  }
}
